import { Button, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import React from 'react';
import { RED } from '../../style/StyleConsts';
import ReduxLanguage from '../ReduxLanguage';
import { IModalViewProps } from './ModalTypes';
import translations from '../../translations/i18next';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface FileSelectData {
  file: File | null;
  fileName: string;
}

export interface FileSelectModalState {
  selectedFile: File | null;
  fileName: string;
}

export interface FileSelectModalProps {
  icon?: JSX.Element;
  fieldLabel: string;
  fileNamePlaceholder: string;
  acceptedFileTypes?: string;
  initialFileName?: string;
  titleMessageKey?: string;
  successMessageKey: string;
  confirmMessageKey?: string;
  cancelMessageKey?: string;
  onConfirm?: (data: FileSelectData) => void;
  onCancel?: () => void;
}

interface ComponentProps extends IModalViewProps<FileSelectModalProps> {}

export default class FileSelectModal extends React.Component<ComponentProps, FileSelectModalState> {
  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      selectedFile: null,
      fileName: props.modalProps?.initialFileName || '',
    };
  }

  render(): React.ReactNode {
    if (!this.props.modalProps) return;
    const { 
      cancelMessageKey, 
      fileNamePlaceholder, 
      acceptedFileTypes,
      onConfirm, 
      confirmMessageKey, 
      icon, 
      titleMessageKey, 
      successMessageKey 
    } = this.props.modalProps;
    const { selectedFile, fileName } = this.state;
    
    return (
      <Dialog open onClose={() => this.handleClose()} TransitionComponent={Transition}>
        <div style={{ padding: 20, minHeight: 500, minWidth: 500, flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {icon ? icon : null}
          <h3 style={{ color: '#3f3f3f' }}>{titleMessageKey ? <ReduxLanguage languageKey={titleMessageKey} /> : ""}</h3>
          <h4 style={{ fontWeight: 100, marginTop: 0, textAlign: 'center' }}>{<ReduxLanguage languageKey={successMessageKey} />}</h4>
          
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', marginBottom: 20, marginTop: 20 }}>
            <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
              <input
                type="file"
                accept={acceptedFileTypes || "*/*"}
                onChange={this.handleFileChange}
                style={{ 
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  opacity: 0,
                  cursor: 'pointer',
                  zIndex: 2
                }}
              />
              <div style={{ 
                minWidth: 350,
                padding: '12px 20px',
                border: '2px dashed #5AC0B1',
                borderRadius: 8,
                backgroundColor: '#f8f8f8',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#5AC0B1',
                fontWeight: 500
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#4a9e92';
                e.currentTarget.style.backgroundColor = '#f0f0f0';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#5AC0B1';
                e.currentTarget.style.backgroundColor = '#f8f8f8';
              }}>
                {selectedFile ? selectedFile.name : <ReduxLanguage languageKey="credits.chooseFile" />}
              </div>
            </div>
            
            <TextField
              value={fileName}
              onChange={this.handleFileNameChange}
              placeholder={translations.t('credits.documentName')}
              variant="outlined"
              style={{ minWidth: 350 }}
              InputProps={{
                style: { minHeight: 55 }
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            {onConfirm ? (
              <Button
                color="primary"
                variant="contained"
                disabled={!selectedFile || !fileName.trim()}
                style={{ marginTop: 20, marginRight: 20, backgroundColor: '#5AC0B1', width: 200, borderRadius: 100 }}
                onClick={() => onConfirm({ file: selectedFile, fileName: fileName.trim() })}
              >
                <ReduxLanguage languageKey={confirmMessageKey || 'forms.save'} />
              </Button>
            ) : null}
            <Button
              color="primary"
              variant="contained"
              style={{ marginTop: 20, backgroundColor: RED, width: 200, borderRadius: 100 }}
              onClick={() => this.handleClose()}
            >
              <ReduxLanguage languageKey={cancelMessageKey || 'forms.close'} />
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }

  private handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0] || null;
    this.setState({ selectedFile: file });
    
    // Auto-populate filename without extension if not already set
    if (file && !this.state.fileName.trim()) {
      const nameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
      this.setState({ fileName: nameWithoutExtension });
    }
  }

  private handleFileNameChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({ fileName: event.target.value });
  }

  private handleClose = (): void => {
    const { hideModal, modalProps } = this.props;
    hideModal();
    if (modalProps && modalProps.onCancel) {
      modalProps.onCancel();
    }
  }
} 